function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Swap"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12.1564 5.47802L9.0514 2.38417C8.82882 2.17272 8.48382 2.17272 8.26124 2.38417L5.15627 5.47802C4.80014 5.82302 5.05611 6.42398 5.54578 6.42398L7.54899 6.42398L7.54899 13.1125C7.54899 13.7246 8.04979 14.2254 8.66188 14.2254C9.27398 14.2254 9.77478 13.7246 9.77478 13.1125L9.77478 6.42398L11.7669 6.42398C12.2677 6.42398 12.5125 5.82302 12.1564 5.47802V5.47802ZM15.7288 21.6261L18.8337 18.5323C19.1899 18.1873 18.9339 17.5863 18.4442 17.5863L16.4521 17.5863L16.4521 10.8867C16.4521 10.2746 15.9513 9.77379 15.3393 9.77379C14.7272 9.77379 14.2264 10.2746 14.2264 10.8867L14.2264 17.5752L12.2343 17.5752C11.7335 17.5752 11.4886 18.1761 11.8448 18.5211L14.9497 21.615C15.1612 21.8376 15.5173 21.8376 15.7288 21.6261V21.6261Z",
  fill: "none"
}));

var SvgSwap = function SvgSwap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSwap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swap.db8ec6a4.svg";
export { ForwardRef as ReactComponent };